import { IConsultantSearchFilterDTO } from 'wisestep-api';

export const emptyConsultantFilter: IConsultantSearchFilterDTO = {
  query: '',
  email: '',
  locations: [],
  preferredLocations: [],
  consultantAllLocationFields: [],
  searchInCurrentLocation: true,
  searchInPreferredLocation: true,
  skillsWithExperience: [{ skill: '', experienceInYears: 0 }],
  createdByEmail: [],
  ownerId: [],
  page: 0,
  size: 20,
  sort: ['createdOn,desc'],
};
export const activeConsultantsQuery: IConsultantSearchFilterDTO = {
  query: '',
  locations: [],
  searchInCurrentLocation: true,
  searchInPreferredLocation: true,
  skillsWithExperience: [],
  isGlobal: true,
  jobTitle: '',
  radiusInMiles: 100,
  page: 0,
  size: 20,
  sort: ['createdOn,desc'],
};
